import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Tag */}
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100/20 text-accent-300 rounded-full">
            / SEO Resource Hub
          </span>

          <div className="mt-6 flex flex-col lg:flex-row gap-10 lg:gap-16">
            {/* Left: Text */}
            <div className="lg:w-3/5">
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                What Is a LitBuy Spreadsheet?
              </h2>
              <p className="mt-5 text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl">
                A <strong>LitBuy Spreadsheet</strong> is a purpose-built digital tool that transforms how modern shoppers organize, compare, and analyze product data. Unlike traditional spreadsheets that offer generic grid functionality, LitBuy Spreadsheets come pre-configured with category-specific templates, automated comparison formulas, and intuitive data visualization features tailored for fashion, accessories, and lifestyle product research.
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-300/80 leading-relaxed max-w-2xl">
                Whether you are comparing Shoes prices, evaluating Hoodies quality metrics, tracking T-Shirts inventory, or analyzing trends across Jackets, Pants, Headwear, and more — LitBuy Spreadsheets provide the structured framework you need to make smarter, faster, and more confident purchasing decisions. Every template is designed with the modern buyer in mind, combining ease of use with powerful analytical capabilities.
              </p>

              {/* Comparison Table */}
              <div className="mt-8 overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="border-b border-foreground-700">
                      <th className="py-3 pr-6 text-sm font-semibold text-white">Feature</th>
                      <th className="py-3 pr-6 text-sm font-semibold text-primary-300">LitBuy Spreadsheet</th>
                      <th className="py-3 text-sm font-semibold text-foreground-400">Traditional Spreadsheet</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm text-foreground-300">
                    <tr className="border-b border-foreground-800/50">
                      <td className="py-3 pr-6 font-medium text-white">Ease of Use</td>
                      <td className="py-3 pr-6 text-accent-300">High — Pre-built templates</td>
                      <td className="py-3 text-foreground-400">Medium — Manual setup</td>
                    </tr>
                    <tr className="border-b border-foreground-800/50">
                      <td className="py-3 pr-6 font-medium text-white">Product Templates</td>
                      <td className="py-3 pr-6 text-accent-300">Yes — 15+ categories</td>
                      <td className="py-3 text-foreground-400">Limited — Generic only</td>
                    </tr>
                    <tr className="border-b border-foreground-800/50">
                      <td className="py-3 pr-6 font-medium text-white">Automation</td>
                      <td className="py-3 pr-6 text-accent-300">Yes — Auto-compare</td>
                      <td className="py-3 text-foreground-400">No — Manual formulas</td>
                    </tr>
                    <tr className="border-b border-foreground-800/50">
                      <td className="py-3 pr-6 font-medium text-white">Collaboration</td>
                      <td className="py-3 pr-6 text-accent-300">Built-in sharing</td>
                      <td className="py-3 text-foreground-400">Basic sharing only</td>
                    </tr>
                    <tr>
                      <td className="py-3 pr-6 font-medium text-white">Analytics</td>
                      <td className="py-3 pr-6 text-accent-300">Advanced — Visual dashboards</td>
                      <td className="py-3 text-foreground-400">Basic — Charts only</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Right: Stats + Image */}
            <div className="lg:w-2/5 flex flex-col items-start gap-8">
              <div className="relative w-full aspect-square rounded-lg overflow-hidden bg-foreground-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20shopping%20items%20including%20sneakers%20watch%20bag%20and%20scarf%20arranged%20in%20a%20spiral%20pattern%20on%20textured%20beige%20linen%2C%20bright%20diffused%20studio%20lighting%2C%20editorial%20lifestyle%20photography%2C%20organized%20product%20collection%2C%20warm%20terra%20cotta%20and%20sand%20accent%20colors%2C%20professional%20catalog%20quality&width=800&height=800&seq=about-v2-litbuy&orientation=squarish"
                  alt="LitBuy Spreadsheet product categories overview"
                  title="LitBuy Spreadsheet - 15+ product categories"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div>
                <span className="font-heading text-6xl md:text-7xl font-bold text-accent-400">15+</span>
                <p className="mt-2 text-sm text-foreground-300 leading-relaxed">
                  Product Categories Covered. From Shoes to Perfumes, all indexed for fast search and easy comparison.
                </p>
                <Link
                  to="/shopping-guide"
                  className="inline-flex items-center gap-2 mt-4 bg-white text-foreground-900 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
                >
                  Shopping Guide
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}